/* NewJaisa collection card helpers (loaded with defer from main-collection /
   main-search). Responsibilities:

   1. Image dots: one delegated click listener swaps the card image to the
      chosen media. Nothing is downloaded until a dot is tapped.
   2. njCollectionCardsInit(root): re-attaches the theme's existing AJAX
      add-to-cart handler (cart.js getATCelement) to cards that were inserted
      by AJAX filtering / sorting / pagination. It never duplicates bindings:
      collection-filter.js only calls it with the container whose innerHTML
      was just replaced, so every [data-add-to-cart] inside is a fresh node.
   3. Virtual pager + block merge for the globally ordered grid
      ([data-nj-priority], see sections/main-collection.liquid): in stock first,
      then pre-order, then sold out, each group in the customer's chosen sort.
*/
(function () {
  'use strict';

  function swapImage(dot) {
    var card = dot.closest('.nj-card');
    if (!card) return;
    var img = card.querySelector('.nj-card__frame img.product-image');
    var src = dot.getAttribute('data-src');
    if (!img || !src) return;
    if (img.getAttribute('src') !== src) {
      img.classList.remove('lazyload');
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = src;
      img.classList.add('lazyloaded');
    }
    var dots = card.querySelectorAll('[data-nj-dot]');
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-active', dots[i] === dot);
    }
  }

  document.addEventListener('click', function (event) {
    var dot = event.target.closest && event.target.closest('[data-nj-dot]');
    if (!dot) return;
    event.preventDefault();
    event.stopPropagation();
    swapImage(dot);
  });

  /* ---- Virtual pager for the globally ordered grid ([data-nj-priority]) ----
     The section prints the cards of the filtered result (250 per Shopify
     block), already grouped in stock -> pre-order -> sold out. This only
     decides which slice is visible. Page number lives in ?vp=N (Shopify's own
     ?page is unusable here, see sections/main-collection.liquid). One
     delegated click listener and one popstate listener for the whole page. */
  /* 13 Oct 2026: price sorts order by card price only; 'item' = any purchasable product (in stock or pre-order) */
  var STATE_ORDER = { item: 0, instock: 0, preorder: 0, soldout: 2, other: 3 }; /* other = search pages / articles */
  function stateRank(el) {
    var r = STATE_ORDER[el.getAttribute('data-nj-state')];
    return typeof r === 'number' ? r : 3;
  }

  function getGrid() { return document.querySelector('[data-nj-priority]'); }

  function getItems(grid) {
    /* collection cards (.nj-product-grid__item) and search results (.col-12) both carry data-nj-state */
    return grid.querySelectorAll(':scope > [data-nj-state]');
  }

  /* Price sorts: Shopify sorts by the product's lowest price over ALL variants,
     but the card shows the cheapest IN-STOCK (or pre-order) variant. Re-sort by
     the price printed on the card so the page reads low->high / high->low. */
  function sortDir() {
    var s = '';
    try { s = new URLSearchParams(window.location.search).get('sort_by') || ''; } catch (e) {}
    if (s.indexOf('price-ascending') !== -1) return 1;
    if (s.indexOf('price-descending') !== -1) return -1;
    return 0;
  }

  function cardPrice(el) {
    if (!el.hasAttribute('data-nj-price')) {
      var p = el.querySelector('.nj-card__price');
      el.setAttribute('data-nj-price', p ? (p.textContent.replace(/[^\d]/g, '') || '0') : '0');
    }
    return parseInt(el.getAttribute('data-nj-price'), 10) || 0;
  }

  /* in stock -> pre-order -> sold out; inside a group: card price on price
     sorts, otherwise Shopify's own order (stable). */
  function orderItems(list) {
    var dir = sortDir();
    return list
      .map(function (el, i) {
        return { el: el, i: i, g: stateRank(el), p: dir ? cardPrice(el) : 0 };
      })
      .sort(function (a, b) { return a.g - b.g || dir * (a.p - b.p) || a.i - b.i; })
      .map(function (o) { return o.el; });
  }

  function placeItems(grid, ordered) {
    var marker = document.createComment('nj-items');
    grid.insertBefore(marker, getItems(grid)[0] || grid.firstChild);
    var frag = document.createDocumentFragment();
    ordered.forEach(function (el) { frag.appendChild(el); });
    grid.insertBefore(frag, marker);
    grid.removeChild(marker);
  }

  function orderGrid(grid) {
    if (!sortDir()) return; /* other sorts: the section's server order is already final */
    placeItems(grid, orderItems(Array.prototype.slice.call(getItems(grid))));
  }

  function currentVp() {
    try {
      var vp = parseInt(new URLSearchParams(window.location.search).get('vp'), 10);
      return vp > 0 ? vp : 1;
    } catch (e) { return 1; }
  }

  function pageLi(n) {
    var li = document.createElement('li');
    li.className = 'pagination-item';
    li.setAttribute('data-nj-vpage', n);
    var a = document.createElement('a');
    a.className = 'pagination-link';
    a.href = '?vp=' + n;
    a.setAttribute('aria-label', 'Page ' + n);
    a.textContent = n;
    li.appendChild(a);
    return li;
  }

  /* Keep the number of page buttons in step with the number of cards
     (needed after more 250-blocks were merged in). */
  function syncPager(grid, pages) {
    var pager = grid.querySelector('[data-nj-vpager]');
    if (!pager) {
      if (pages < 2) return;
      /* page 1 block alone fitted on one page: build the pager from scratch */
      pager = document.createElement('div');
      pager.className = 'pagination-box nj-vpager';
      pager.setAttribute('data-nj-vpager', '');
      pager.innerHTML =
        '<ul class="pagination">' +
        '<li class="pagination-item pagination-icon disabled" data-nj-vprev><a href="#" class="pagination-link" aria-label="Previous">&lsaquo;</a></li>' +
        '<li class="pagination-item pagination-icon" data-nj-vnext><a href="#" class="pagination-link" aria-label="Next">&rsaquo;</a></li>' +
        '</ul>';
      grid.appendChild(pager);
    }
    var ul = pager.querySelector('ul');
    var next = pager.querySelector('[data-nj-vnext]');
    var lis = pager.querySelectorAll('[data-nj-vpage]');
    if (lis.length === pages) return;
    for (var i = 0; i < lis.length; i++) lis[i].parentNode.removeChild(lis[i]);
    for (var n = 1; n <= pages; n++) ul.insertBefore(pageLi(n), next);
    pager.setAttribute('data-nj-pages', pages);
    pager.hidden = pages < 2;
  }

  function showPage(page, opts) {
    opts = opts || {};
    var grid = getGrid();
    if (!grid) return;
    var size = parseInt(grid.getAttribute('data-nj-page-size'), 10) || 18;
    var items = getItems(grid);
    var pages = Math.max(1, Math.ceil(items.length / size));
    page = Math.min(Math.max(1, page || 1), pages);
    for (var i = 0; i < items.length; i++) {
      items[i].hidden = Math.floor(i / size) + 1 !== page;
    }
    grid.setAttribute('data-nj-ready', '');
    grid.setAttribute('data-nj-current', page);

    syncPager(grid, pages);
    var pager = grid.querySelector('[data-nj-vpager]');
    if (pager) {
      var lis = pager.querySelectorAll('[data-nj-vpage]');
      for (var j = 0; j < lis.length; j++) {
        var n = parseInt(lis[j].getAttribute('data-nj-vpage'), 10);
        lis[j].classList.toggle('active', n === page);
        /* long results: show first, last and 2 pages either side of the current one */
        lis[j].hidden = !(n === 1 || n === pages || Math.abs(n - page) <= 2);
      }
      var prev = pager.querySelector('[data-nj-vprev]');
      var next = pager.querySelector('[data-nj-vnext]');
      if (prev) prev.classList.toggle('disabled', page <= 1);
      if (next) next.classList.toggle('disabled', page >= pages);
    }

    if (opts.push) {
      try {
        var u = new URL(window.location.href);
        if (page > 1) u.searchParams.set('vp', page); else u.searchParams.delete('vp');
        window.history.pushState({ njvp: page }, '', u.toString());
      } catch (e) {}
    }
    if (opts.scroll) {
      var top = grid.getBoundingClientRect().top + window.pageYOffset - 150;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
    if (window.lazySizes && window.lazySizes.loader && window.lazySizes.loader.checkElems) {
      window.lazySizes.loader.checkElems();
    }
  }

  /* ---- Results above 250: merge the other Shopify blocks ----
     Shopify returns at most 250 products per render, so the section only has
     block 1. Fetch blocks 2..N of the SAME url (same sort + filters) through
     the Section Rendering API and re-group everything, so an in-stock product
     from block 2 still comes before every pre-order product of block 1. */
  var mergeToken = 0;

  function blockUrl(grid, block) {
    var u = new URL(window.location.href);
    u.searchParams.delete('vp');
    u.searchParams.set('page', block);
    u.searchParams.set('section_id', grid.getAttribute('data-nj-section'));
    return u.pathname + '?' + u.searchParams.toString();
  }

  function mergeBlocks(grid) {
    var blocks = parseInt(grid.getAttribute('data-nj-blocks'), 10) || 1;
    if (blocks < 2 || grid.hasAttribute('data-nj-merged')) return;
    grid.setAttribute('data-nj-merged', 'loading');
    var token = ++mergeToken;
    var requests = [];
    for (var b = 2; b <= blocks; b++) {
      requests.push(
        fetch(blockUrl(grid, b), { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var g = doc.querySelector('[data-nj-priority]');
            return g ? Array.prototype.slice.call(getItems(g)) : [];
          })
      );
    }
    Promise.all(requests).then(function (lists) {
      /* grid was replaced by an AJAX filter/sort meanwhile: drop this result */
      if (token !== mergeToken || !document.body.contains(grid)) return;

      var seen = {};
      var all = [];
      function add(el) {
        var pid = el.getAttribute('data-nj-pid');
        if (pid && seen[pid]) return; /* a product can move between blocks while we fetch */
        if (pid) seen[pid] = true;
        all.push(el);
      }
      Array.prototype.forEach.call(getItems(grid), add);
      var fresh = document.createElement('div');
      lists.forEach(function (list) {
        list.forEach(function (el) {
          var node = document.importNode(el, true);
          var before = all.length;
          add(node);
          if (all.length > before) fresh.appendChild(node);
        });
      });

      /* bind add-to-cart on the new cards only, before they move into the grid */
      if (typeof window.getATCelement === 'function') window.getATCelement(fresh);

      /* re-group all blocks together (chosen sort kept inside each group) */
      placeItems(grid, orderItems(all));

      grid.setAttribute('data-nj-merged', 'done');
      showPage(currentVp(), {});
    }).catch(function () {
      /* network error: keep block 1 as it is (still correctly grouped) */
      if (token === mergeToken) grid.setAttribute('data-nj-merged', 'failed');
    });
  }

  /* cart.js binds add-to-cart on window load for the whole document, so new
     cards are merged only after load to avoid binding them twice. */
  function whenLoaded(fn) {
    if (document.readyState === 'complete') fn();
    else window.addEventListener('load', fn);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-nj-vpager] a');
    if (!link) return;
    event.preventDefault();
    var li = link.closest('li');
    if (!li || li.classList.contains('disabled') || li.classList.contains('active')) return;
    var grid = getGrid();
    var cur = parseInt((grid && grid.getAttribute('data-nj-current')) || '1', 10);
    var target = cur;
    if (li.hasAttribute('data-nj-vprev')) target = cur - 1;
    else if (li.hasAttribute('data-nj-vnext')) target = cur + 1;
    else target = parseInt(li.getAttribute('data-nj-vpage'), 10) || 1;
    showPage(target, { push: true, scroll: true });
  });

  window.addEventListener('popstate', function () {
    if (getGrid()) showPage(currentVp(), {});
  });

  function initPager(reset) {
    var grid = getGrid();
    if (!grid) return;
    if (!reset) {
      orderGrid(grid);
      showPage(currentVp(), {});
      whenLoaded(function () { mergeBlocks(grid); });
      return;
    }
    /* After an AJAX sort/filter, collection-filter.js updates the address bar
       right after calling us; the price order and extra blocks must use the
       NEW url, so wait one tick. */
    showPage(1, {});
    setTimeout(function () {
      if (!document.body.contains(grid)) return;
      orderGrid(grid);
      showPage(1, {});
      whenLoaded(function () { mergeBlocks(grid); });
    }, 0);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initPager(false); });
  } else {
    initPager(false);
  }

  /* Called by collection-filter.js after a filter / sort AJAX refresh. */

  window.njCollectionCardsInit = function (root) {
    root = root || document;
    if (typeof window.getATCelement === 'function') {
      window.getATCelement(root);
    }
    mergeToken++; /* cancel any merge still running for the old grid */
    initPager(true); /* new result set -> always start at its first page */
  };
})();